import styled from 'styled-components';
import { TemplateMode } from './PersonalizeCase.types';

export const LoadingContainer = styled.div`
  display: flex;
  height: 70vh;
  align-items: center;
  justify-content: center;
`;

export const LoaderContainer = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  opacity: 1 !important;
`;

export const Container = styled.div<{ isLoading: boolean }>`
  display: flex;
  opacity: ${({ isLoading }) => (isLoading ? '0.2' : '1')};
  ${({ theme }) => theme.breakpoints.down('md')} {
    flex-direction: column;
  }
`;

export const ClamshellContainer = styled.div`
  width: 50%;
  display: flex;
  justify-content: center;
  ${({ theme }) => theme.breakpoints.down('md')} {
    width: 100%;
  }
`;

export const PreviewWrapper = styled.div``;

export const PersonalizationContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  /* border: 1px solid blue; */
  align-items: center;
  ${({ theme }) => theme.breakpoints.down('md')} {
    width: 100%;
  }
`;

export const PersonalizeOptionsSection = styled.div`
  width: 60%;
  ${({ theme }) => theme.breakpoints.down('md')} {
    width: 100%;
  }
`;

export const LogoUploadSection = styled.div<{ templateMode: TemplateMode }>`
  border: 1px dashed #c4c4c4;
  border-radius: 5px;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
`;

export const QRCodeSection = styled.div<{ templateMode: TemplateMode }>`
  margin-top: 20px;
  border: 1px solid #c4c4c4;
  border-radius: 5px;
  display: flex;
  background: white;
  flex-direction: column;
  padding: 35px;
`;

export const ActionButtonContainer = styled.div<{ templateMode: TemplateMode }>`
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
`;

export const LogoUploadIconWrpper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 5px;
  cursor: pointer;
`;

export const LogoUploadTitle = styled.div`
  font-size: 1.2rem;
  font-weight: 400;
  color: #626262;
`;

export const ListWithTitle = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
`;

export const ListTitle = styled.div`
  font-weight: 700;
  color: #626262;
`;

export const List = styled.ul`
  margin-top: 5px;
`;

export const ListItem = styled.li`
  margin-bottom: 4px;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 3px;
`;

export const IconWrapper = styled.div`
  cursor: pointer;
  padding: 8px;
  margin-right: 3px;
  /* border: 1px solid rgba(136, 136, 136, 1); */
  border-radius: 50px;
`;

export const Title = styled.div`
  font-size: 2.2rem;
  font-weight: 500;
`;

export const DownloadButtonWrapper = styled.div`
  margin-top: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TCWrapper = styled.div`
  margin-top: 10px;
  text-align: left;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
  justify-content: center;
  > input {
    width: 50px;
    height: 50px;
  }
  > div {
    margin-left: 3px;
  }

  > label {
    cursor: pointer;
  }
`;

export const LogoErrorMessage = styled.div`
  text-align: center;
  color: rgba(212, 63, 88, 1);
`;

export const DisclaimerCustom = styled.div`
  font-size: 0.85rem;
  text-align: center;
`;
